<template>
  <section id="mission-and-vision">
    <v-container>
      <v-layout row wrap justify-center align-center>
        <v-flex class="text-xs-center" xs12 md6>
          <span>Our</span>
          <span>Mission</span>
          <span>And</span>
          <span>Vision</span>
        </v-flex>
        <v-flex class="text-xs-center" xs10 sm8 md6>
          <div id="mission">
            <h1 class="headline my-4">Mission</h1>
            <div
              class="subheading"
            >UCCC exists to love God and man with a renewed mind and spirit and to magnify Christ and make him known.</div>
          </div>
          <div id="vision">
            <h1 class="headline my-4">Vision</h1>
            <div
              class="subheading"
            >UCCC’s vision is to reach our community with the message and love of God, one family at a time.</div>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
export default {
  name: "MissionAndVision",
  data() {
    return {};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#mission-and-vision {
  min-height: 50vh;
  display: flex;
  align-items: center;
  background-color: #ddd;
  perspective: 500px;
  overflow: hidden;
}

#mission-and-vision .row {
  display: flex;
  margin: 100px auto;
}

#mission-and-vision .row::before {
  content: "";
  width: 150%;
  height: 190px;
  display: block;
  background-color: #fff;
  position: absolute;
  top: -100px;
  right: 0;
  transform: rotateY(-9deg);
}

#mission-and-vision .row::after {
  content: "";
  width: 150%;
  height: 190px;
  display: block;
  background-color: #fff;
  position: absolute;
  right: 0;
  bottom: -100px;
  transform: rotateY(-9deg);
}

#mission-and-vision span {
  display: block;
  margin: 0;
  font-size: 72px;
  font-weight: 300;
  text-transform: uppercase;
}

#mission-and-vision span:nth-child(2),
#mission-and-vision span:nth-child(4) {
  font-size: 48px;
}

#mission-and-vision span:nth-child(1),
#mission-and-vision span:nth-child(3) {
  font-size: 24px;
}

#mission,
#vision {
  margin: 24px 0;
  padding: 24px;
  color: #fff;
  border-bottom: 2px solid rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  box-shadow: 0 40px 30px rgba(0, 0, 0, 0.125);
}

#mission {
  background-color: #2196f3;
}

#vision {
  background-color: #1b9a59;
}

@media (min-width: 960px) {
  #mission,
  #vision {
    transform: rotateX(9deg);
    transform: rotateY(-9deg);
    box-shadow: 25px 40px 30px rgba(0, 0, 0, 0.125);
  }
  #mission-and-vision span:nth-child(2),
  #mission-and-vision span:nth-child(4) {
    font-size: 72px;
  }
  #mission-and-vision span:nth-child(1),
  #mission-and-vision span:nth-child(3) {
    font-size: 48px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/MissionAndVision.vue